import React from 'react'
import { Link } from 'react-router-dom'
import MobileMenu from '../MobileMenu/MobileMenu'



const HeaderS3 = (props) => {


    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }


    return (
        <header id="header">
            <div className={"" + props.hclass}>
                <nav className="navigation navbar navbar-expand-lg navbar-light">
                    <div className="container-fluid">
                        <div className="row align-items-center">
                            <div className="col-md-3 col-3 d-lg-none dl-block">
                                <MobileMenu />
                            </div>
                            <div className="col-xl-2 col-lg-2 col-md-6 col-6">
                                <div className="navbar-header">
                                    <Link onClick={ClickHandler} className="navbar-brand" to="/home"><img src={props.Logo}
                                        alt="" height={"90px"} /></Link>
                                </div>
                            </div>
                            <div className="col col-xl-5 col-lg-8 col-md-1 col-1">
                                <div id="navbar" className="collapse navbar-collapse navigation-holder">
                                    <button className="menu-close"><i className="ti-close"></i></button>
                                    <ul className="nav navbar-nav mb-2 mb-lg-0">
                                        <li className="menu-item-has-children">
                                            <Link onClick={ClickHandler} to="/">Home</Link>
                                            {/* <ul className="sub-menu">
                                                <li><Link onClick={ClickHandler} to="/home">Home style 1</Link></li>
                                                <li><Link onClick={ClickHandler} to="/home-2">Home style 2</Link></li>
                                                <li><Link onClick={ClickHandler} to="/home-3">Home style 3</Link></li>
                                            </ul> */}
                                        </li>
                                        <li><Link onClick={ClickHandler} to="/about">About</Link></li>
                                        <li className="menu-item-has-children">
                                            <Link onClick={ClickHandler} to="#">Products</Link>
                                            <ul className="sub-menu">
                                        <li className="menu-item-has-children">
                                        <Link onClick={ClickHandler} to="#">Water Tank</Link>
                                       <ul className="sub-menu">
                                      
                                         <li><Link onClick={ClickHandler} to="/tank6">6 Layer Water Tank</Link></li>
                                         <li><Link onClick={ClickHandler} to="/tank10">10 Layer Water Tank</Link></li>
                                          <li><Link onClick={ClickHandler} to="/tanklayer6">6 Layer Loft Water Tank</Link></li>
                                       </ul>
                                       </li>
                                         <li><Link onClick={ClickHandler} to="/ppFabric">PP Fabric</Link></li>
                                         <li><Link onClick={ClickHandler} to="/wovenBag">PP Woven Bag</Link></li>
                                         <li><Link onClick={ClickHandler} to="/multicolorBag">BOPP Multicolor Bag</Link></li>
                                         <li><Link onClick={ClickHandler} to="/craftPaperBag">PP Laminated Kraft</Link></li>
                                         <li><Link onClick={ClickHandler} to="/lenoBag">Leno Bag</Link></li>
                                         <li><Link onClick={ClickHandler} to="/corrugatedBox">Corrugated Box</Link></li>
                                        </ul>
                                        </li>
                                    
                                        {/* <li className="menu-item-has-children">
                                            <Link onClick={ClickHandler} to="#">Machinery</Link>
                                             <ul className="sub-menu">
                                                <li><Link onClick={ClickHandler} to="/project">Project Style 1</Link></li>
                                                <li><Link onClick={ClickHandler} to="/project-s2">Project Style 2</Link></li>
                                                <li><Link onClick={ClickHandler} to="/project-s3">Project Style 3</Link></li>
                                                <li><Link onClick={ClickHandler} to="/project-single/Special-Transport-Solutions5">Project Single</Link></li>
                                            </ul> 
                                        </li> */}
                                        {/* <li className="menu-item-has-children">
                                            <Link onClick={ClickHandler} to="/#">Blog</Link>
                                            <ul className="sub-menu">
                                                <li><Link onClick={ClickHandler} to="/blog">Blog right sidebar</Link></li>
                                                <li><Link onClick={ClickHandler} to="/blog-left-sidebar">Blog left sidebar</Link></li>
                                                <li><Link onClick={ClickHandler} to="/blog-fullwidth">Blog fullwidth</Link></li>
                                                <li className="menu-item-has-children">
                                                    <Link onClick={ClickHandler} to="#">Blog details</Link>
                                                    <ul className="sub-menu">
                                                        <li><Link onClick={ClickHandler} to="/blog-single/Why-Industry-Are-A-Juicy-Target-For-Cyberattack">Blog details right sidebar</Link>
                                                        </li>
                                                        <li><Link onClick={ClickHandler} to="/blog-single-left-sidebar/Why-Industry-Are-A-Juicy-Target-For-Cyberattack">Blog details left
                                                            sidebar</Link></li>
                                                        <li><Link onClick={ClickHandler} to="/blog-single-fullwidth/Why-Industry-Are-A-Juicy-Target-For-Cyberattack">Blog details
                                                            fullwidth</Link></li>
                                                    </ul>
                                                </li>
                                            </ul>
                                        </li> */}
                                        <li><Link onClick={ClickHandler} to="/contact">Contact</Link></li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-xl-5 col-lg-2 col-md-2 col-2">
                                <div className="header-right">
                                    <div className="contact-info">
                                        <div className="icon">
                                            <a href="tel:+917565034859"><i className="fi flaticon-phone-call"></i></a>
                                        </div>
                                        <div className="info-text">
                                            <span>Call Us:</span>
                                            <a href="tel:+917565034859" style={{color:"#626B72"}}>75650 34859</a>
                                        </div>
                                    </div>
                                    <div className="contact-info">
                                        <div className="icon">
                                            <a href="mailto:snbsindustries@gmail.com" ><i className="fi flaticon-email"></i></a>
                                        </div>
                                        <div className="info-text">
                                            <span>E-mail Now:</span>
                                            <a href="mailto:snbsindustries@gmail.com" style={{color:"#626B72"}}>snbsindustries@gmail.com</a>
                                        </div>
                                    </div>
                                    <div className="close-form">
                                        <Link onClick={ClickHandler} className="theme-btn" to="/contact">Inquiry now</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </nav>
            </div>
        </header>
    )
}


export default HeaderS3;

















